import { render, staticRenderFns } from "./ColaboradorDetalhesCadastroUnico.vue?vue&type=template&id=62f17b4a"
import script from "./ColaboradorDetalhesCadastroUnico.vue?vue&type=script&lang=js"
export * from "./ColaboradorDetalhesCadastroUnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports